export default class BlockFilteredPackage {
    constructor(container, options) {
        const defaultOptions = {
            venueSelector: '.select-venue .venues .venue',
            pleaseSelect: '.placeholder-please-select-message',
            swiperActiveWrapper: '.swiper .swiper-wrapper',
            availableSlide: '.package-data .swiper-slide',
            swiperElement: '.swiper',
            swiperPagination: '.swiper-pagination',
            swiperPaginationNext: '.swiper-button-next',
            swiperPaginationPrevious: '.swiper-button-prev',
            swiperButton: '.swiper-button',
            modal: '.package-modal',
            modalOpenButton: '.modal-trigger',
            modalCloseButton: '.icon-modal-close',
            isSwiperActive: true
        };
        this.options = Object.assign({}, defaultOptions, options);
        
        this.container = document.querySelector(container);
        this.venueSelectors = this.container.querySelectorAll(this.options.venueSelector);
        this.pleaseSelect = this.container.querySelector(this.options.pleaseSelect);
        this.availableSlides = this.container.querySelectorAll(this.options.availableSlide);
        this.swiperActiveWrapper = this.container.querySelector(this.options.swiperActiveWrapper);
        this.swiperElem = this.container.querySelector(this.options.swiperElement);
        this.swiperPagination = this.container.querySelector(this.options.swuperPagination);
        this.swiperPaginationNext = this.container.querySelector(this.options.swiperPaginationNext);
        this.swiperPaginationPrevious = this.container.querySelector(this.options.swiperPaginationPrevious);
        this.swiperButtons = this.container.querySelectorAll(this.options.swiperButton);
        this.isSwiperActive = this.options.isSwiperActive;
        
        this.modals = this.container.querySelectorAll(this.options.modal);
        this.modalCloseButtons = this.container.querySelectorAll(this.options.modalCloseButton);
        
        this.swiper = null;

        if(this.isSwiperActive)
            this.initSwiper();
        
        this.setEvents();
    }

    setEvents() {
        let self = this;
        this.venueSelectors.forEach(venue => {
            venue.addEventListener('click', function() {
                self.onVenueSelect(this);
            });
        });

        this.modalCloseButtons.forEach(closeButton => {
            closeButton.addEventListener('click', e => {
                e.stopPropagation()
                self.closeModals();
            })
        });

        this.setModalEvents();
    }

    setModalEvents() {
        let self = this;

        let modalOpenButtons = this.swiperElem.querySelectorAll(this.options.modalOpenButton);
        modalOpenButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.stopPropagation()
                self.openModal(button.dataset.modalOpen);
            });
        });
    }
    
    openModal(id) {
        this.modals.forEach(modal => {
            if (modal.dataset.modalId === id) {
                modal.classList.add('active');
            }
        })
    }
    closeModals() {
        this.modals.forEach(modal => {
            modal.classList.remove('active');
        });
    }

    onVenueSelect(elem) {
        var id = elem.dataset.id;
        this.venueSelect(id);
    }

    venueSelect(id) {
        this.filterVenues(id);

        if (this.pleaseSelect !== null) {
            this.pleaseSelect.style.display = 'none';
        }
        // Show the swiper buttons
        this.swiperButtons.forEach(button => {
            button.style.opacity = 1;
        });

        this.setModalEvents();
    }

    filterVenues(id) {
        if(this.isSwiperActive)
            this.swiper.destroy(true, true)
        
        this.swiperActiveWrapper.innerHTML = '';
        this.availableSlides.forEach(slide => {
            let venues = slide.dataset.venue.split('|');
            let shouldBeVisible = venues.filter(x=> x === id).length;
            
            if (shouldBeVisible) {
                this.swiperActiveWrapper.append(slide.cloneNode(true));
            }
        })

        if(this.isSwiperActive)
            this.initSwiper();
    }
    
    initSwiper() {
        this.swiper = new Swiper(this.swiperElem, {
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1.15,
            centeredSlides: true,
            slideToClickedSlide: true,
            initialSlide: 0,
            spaceBetween: 15,
            grabCursor: true,
            autoResize: false,
            pagination: {
                el: this.swiperPagination,
                clickable: true
            },
            navigation: {
                nextEl: this.swiperPaginationNext,
                prevEl: this.swiperPaginationPrevious,
            },
            breakpoints: {
                998: {
                    slidesPerView: 3.15,
                    centeredSlides: false,
                    spaceBetween: 30
                },
                1200: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    spaceBetween: 30
                }
            }
        })
    }
}